import React, { Component } from 'react';

class Footer extends Component {
    state = {  }
    render() { 
        return (  
            <footer className="footer p-3 d-flex justify-content-center">
                <p>&#169;Post It</p>
            </footer>

        );
    }
}
 
export default Footer;